import { useEffect } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";

import { getDisplayUsername } from "~/utils";

import MainLayout from "./components/main-layout";
import { AuthProvider } from "./contexts/auth";

// The one, the only. Ben gets Comic Sans; everyone else is spared.
const COMIC_SANS_USER = "ben@turbopuffer.com";

export default function Layout() {
  useEffect(() => {
    const isBen = getDisplayUsername() === COMIC_SANS_USER;
    document.documentElement.classList.toggle("comic-sans", isBen);
  }, []);

  return (
    <AuthProvider>
      <ScrollRestoration />
      <MainLayout>
        <Outlet />
      </MainLayout>
      <script
        dangerouslySetInnerHTML={{
          __html: `window.ENV = ${JSON.stringify({
            NODE_ENV: process.env.NODE_ENV,
          })}`,
        }}
      />
    </AuthProvider>
  );
}
